import { Validators } from '@angular/forms';
import { DynamicForm, Fields } from 'projects/pplus/src/lib/models/components/dynamic-form.model';

const GENERALES: Fields[] = [
    {
        disabled: true,
        name: 'profileId',
        placeholder: 'ID',
        type: 'text',
        value: '',
    },
    {
        name: 'description',
        placeholder: 'DESCRIPCION',
        type: 'text',
        value: '',
        validators: [
            Validators.required,
        ],
    },
    {
        name: 'roleIds',
        value: [],
        type: 'select',
        multiple: true,
        searchName: 'rolesSearch',
        label: 'ROLES',
        options: []
    },
    {
        name: 'activated',
        placeholder: 'ACTIVADO',
        type: 'checkbox',
        value: true,
    },
];

export const PROFILES_FORM: DynamicForm[] = [
    {
        title: 'DATOS GENERALES',
        open: true,
        fields: GENERALES,
    },
];
